module.exports = __webpack_public_path__ + "img/分析工具.b5e77d6a.jpg";